import { InfoOutlined } from '@mui/icons-material';
import { AzurePolicy } from '@costco-service-catalog/bff-types';
import {
  Box,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { useAzurePolicies } from '../../../../hooks';

interface AddSubscriptionPolicySelectProps {
  selectedPolicyKeys: string[] | undefined;
  handleChangePolicy: (policy: AzurePolicy) => void;
  handleChangePolicyMode: (azurePolicy: AzurePolicy) => void;
  environmentModes: {
    policyKey: string;
    mode: 'Audit' | 'Deny';
  }[];
}

const AddSubscriptionPolicySelect = (
  props: AddSubscriptionPolicySelectProps
) => {
  const {
    selectedPolicyKeys,
    handleChangePolicy,
    handleChangePolicyMode,
    environmentModes,
  } = props;
  const {
    data: azurePolicyList,
    loading: azurePolicyListLoading,
    error: azurePolicyListError,
  } = useAzurePolicies();

  return (
    <Box padding="1rem">
      <Typography fontWeight="500">Policies to Apply: </Typography>
      <br />
      <Box maxHeight="400px" sx={{ overflowY: 'auto' }}>
        <List disablePadding>
          {azurePolicyList.map((azurePolicy) => (
            <ListItem key={azurePolicy.key} disableGutters disablePadding>
              <ListItemIcon>
                <Checkbox
                  data-testid="checkbox-1"
                  checked={Boolean(
                    selectedPolicyKeys?.find((v) => v === azurePolicy.key)
                  )}
                  onClick={() => {
                    handleChangePolicy(azurePolicy);
                  }}
                />
              </ListItemIcon>
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    flex: 2,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <Box padding="4px">
                    <ListItemText>{azurePolicy.displayName}</ListItemText>
                  </Box>
                  <Box padding="8px">
                    <Tooltip
                      title={azurePolicy.description}
                      placement="top-start"
                    >
                      <InfoOutlined htmlColor="graytext" fontSize="small" />
                    </Tooltip>
                  </Box>
                </Box>

                <Box sx={{ flex: 2 }}>
                  {selectedPolicyKeys?.find((v) => v === azurePolicy.key) && (
                    <Box
                      sx={{
                        paddingX: '4rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant="body2">Audit</Typography>
                      <Switch
                        checked={
                          environmentModes.find(
                            (v) => v.policyKey === azurePolicy.key
                          )?.mode === 'Deny'
                        }
                        onClick={() => {
                          handleChangePolicyMode(azurePolicy);
                        }}
                      />
                      <Typography variant="body2">Deny</Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default AddSubscriptionPolicySelect;
